
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import ChillerDataCard from '@/components/energy/chillers/ChillerDataCard';
import ChillerPlantOverview from '@/components/energy/chillers/ChillerPlantOverview';
import { Clock } from 'lucide-react';

const ChillerManagementGrid: React.FC = () => {
  // System performance data
  const performanceData = {
    energyEfficiency: 85.2,
    efficiencyChange: 3.1,
    totalRuntime: {
      total: 9575,
      chiller1: 3500,
      chiller2: 3130,
      chiller3: 2945
    },
    lastMaintenance: '10-Apr-2024',
    lastMaintenanceChiller: 'Chiller 3'
  };

  return (
    <div className="space-y-4 p-4">
      <Card className="bg-white dark:bg-gray-800 border-blue-100 dark:border-blue-900">
        <CardHeader className="pb-2">
          <CardTitle className="text-lg font-semibold">Chiller Plant Dashboard</CardTitle>
        </CardHeader>
      </Card>
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6">
        <ChillerDataCard title="Main Chiller - Chiller 1" chillerNumber={1} />
        <ChillerDataCard title="Secondary Chiller - Chiller 2" chillerNumber={2} />
        <ChillerDataCard title="Auxiliary Chiller - Chiller 3" chillerNumber={3} />
      </div>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <ChillerPlantOverview />
        
        <Card className="bg-white dark:bg-gray-800">
          <CardHeader>
            <CardTitle className="text-lg">System Performance</CardTitle>
          </CardHeader>
          <CardContent className="p-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="border rounded-md p-4">
                <h3 className="text-sm font-medium mb-2">Energy Efficiency</h3>
                <div className="flex justify-between items-center">
                  <span className="text-2xl font-bold">{performanceData.energyEfficiency}%</span>
                  <span className="text-emerald-500 text-sm">▲ {performanceData.efficiencyChange}%</span>
                </div>
                <p className="text-sm text-muted-foreground mt-1">vs last month</p>
              </div>
              
              <div className="border rounded-md p-4">
                <h3 className="text-sm font-medium mb-2">Total Runtime</h3>
                <div className="flex justify-between items-center">
                  <span className="text-2xl font-bold">{performanceData.totalRuntime.total.toLocaleString()} hrs</span>
                  <span className="text-sm text-muted-foreground">Lifetime</span>
                </div>
                <div className="mt-3 space-y-1 text-xs">
                  <div className="flex justify-between">
                    <span>Chiller 1:</span>
                    <span className="font-medium">{performanceData.totalRuntime.chiller1.toLocaleString()} hrs</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Chiller 2:</span>
                    <span className="font-medium">{performanceData.totalRuntime.chiller2.toLocaleString()} hrs</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Chiller 3:</span>
                    <span className="font-medium">{performanceData.totalRuntime.chiller3.toLocaleString()} hrs</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-4 border rounded-md p-4">
              <div className="flex items-center gap-2">
                <Clock className="h-4 w-4 text-amber-500" />
                <h3 className="text-sm font-medium">Last Maintenance</h3>
              </div>
              <div className="mt-2">
                <div className="flex justify-between items-center">
                  <span className="text-sm">{performanceData.lastMaintenanceChiller}</span>
                  <div className="flex items-center gap-1">
                    <span className="bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-300 px-2 py-0.5 rounded text-xs">
                      {performanceData.lastMaintenance}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ChillerManagementGrid;
